import React, { FC, useEffect, useRef, useState } from 'react';
import Calendar, { Detail, ViewCallbackProperties } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
//import { ShowTimeSlots, TimeSlot } from './ShowTimeSlots';
import { ShowTimeSlots } from './ShowTimeSlots';
import { DateAndTimeStore } from '../Stores/DateAndTimeSlotStoreClass';
import { observer } from "mobx-react-lite";
import { ApiClient, AvailableTimeSlot } from './Api/ApiClient';
import { AnyARecord } from 'dns';

// type DayModel = {
//     date: Date,
//     timeSlots: TimeSlot[]
// }

// const testDays: DayModel[] =
//     [
//         {
//             //st
//             date: new Date(2022, 7, 31),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //ct
//             date: new Date(2022, 8, 1),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //pa
//             date: new Date(2022, 8, 2),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //po
//             date: new Date(2022, 8, 5),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ut
//             date: new Date(2022, 8, 6),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //st
//             date: new Date(2022, 8, 7),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ct
//             date: new Date(2022, 8, 8),
//             //freeDay: new Date(2022, 8, 8),
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //pa
//             date: new Date(2022, 8, 9),
//             //freeDay: new Date(2022, 8, 9),
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //po
//             date: new Date(2022, 8, 12),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ut
//             date: new Date(2022, 8, 13),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //st
//             date: new Date(2022, 8, 14),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ct
//             date: new Date(2022, 8, 15),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //pa
//             date: new Date(2022, 8, 16),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //po
//             date: new Date(2022, 8, 19),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ut
//             date: new Date(2022, 8, 20),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //st
//             date: new Date(2022, 8, 21),
//             ////freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ct
//             date: new Date(2022, 8, 22),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //pa
//             date: new Date(2022, 8, 23),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //po
//             date: new Date(2022, 8, 26),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ut
//             date: new Date(2022, 8, 27),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //st
//             date: new Date(2022, 8, 28),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ct
//             date: new Date(2022, 8, 29),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         {
//             //pa
//             date: new Date(2022, 8, 30),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }, { from: "13", to: "13:30" }, { from: "13:30", to: "14" }, { from: "14", to: "14:30" }]
//         },
//         //rijen
//         {
//             //po
//             date: new Date(2022, 9, 3),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },
//         {
//             //ut
//             date: new Date(2022, 9, 4),
//             //freeDay: undefined,
//             timeSlots: [{ from: "9", to: "9:30" }, { from: "9:30", to: "10" }, { from: "10", to: "10:30" }, { from: "10:30", to: "11" }, { from: "11", to: "11:30" }, { from: "11:30", to: "12" }]
//         },

//     ]



export const MyCalendar = observer(
    () => {

        const selectedDate = DateAndTimeStore.date;
        const slots = DateAndTimeStore.availableTimeSlots;
        const [filter, setFilter] = useState(getDefaultFilter());
        //const [slots, setSlots] = useState<AvailableTimeSlot[] | null>(null);
        const [data, setData] = useState<Date[]>([]);
        const [loading, setLoading] = useState(true);

        useEffect(() => {
            async function fetchData() {
                //console.log(filter);
                const response = await ApiClient.getAvailableDays(filter[0], filter[1]);
                setData(response.result);
                //console.log(data);
                setLoading(false);
            }
            fetchData();
        }, [filter, selectedDate]);



        const handlerOnClickDay = async (value: Date) => {
            const response = await ApiClient.getAvailableTimeSlots(value);
            DateAndTimeStore.setAvailableTimeSlots(response.result);
        }



        const handlerOnActiveStartChange = (v: ViewCallbackProperties) => {
            setFilter([v.activeStartDate, getDateWithLastDayOfMonth(v.activeStartDate)]);
        }

        if (loading) return null;
        return (

            <div className='calendarAndSlotsInRow'>
                <div>
                    <Calendar
                        onChange={DateAndTimeStore.setDate}
                        value={selectedDate}
                        onClickDay={handlerOnClickDay}
                        view='month'
                        //onActiveStartDateChange={(v) => console.log(v)}
                        onActiveStartDateChange={handlerOnActiveStartChange}
                        //minDate={getTodayMidnight()}
                        // maxDate={getMaxDay()}
                        tileDisabled={({ date, view }) => {
                            //console.log(data.map(d => d.getTime()), date.getTime());
                            if ((view === 'month') &&
                                (data.some(x => x.getTime() === date.getTime()))) {
                                //console.log("Neni disabled");
                                return false;
                            }
                            return true;
                        }}
                    />
                </div>
                {slots !== null ? <ShowTimeSlots slots={slots} /> : null}
            </div>
        );
    }
)

const getTodayMidnight = (): Date => {
    const today: Date = new Date();
    //console.log("TOTO JE TO DATUM", today.getFullYear(), today.getMonth(), today.getDate())
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
}

//metoda ktera mne z date vrati date s poslednim dnem v mesici
const getDateWithLastDayOfMonth = (date: Date): Date => {
    return new Date(date.getFullYear(), date.getMonth(), getDaysInMonth(date.getMonth() + 1, date.getFullYear()));
}

const getDefaultFilter = (): Date[] => {
    const today: Date = getTodayMidnight();
    //console.log(getDateWithLastDayOfMonth(today));
    return [today, getDateWithLastDayOfMonth(today)];
}

//obecna metoda pro ziskani posledniho dne v mesici
const getDaysInMonth = (m: number, y: number): number => {
    return m === 2 ? y & 3 || !(y % 25) && y & 15 ? 28 : 29 : 30 + (m + (m >> 3) & 1);
}

// (window as any).test = getDaysInMonth;
// (window as any).test2 = getTodayMidnight;
// (window as any).test3 = getDateWithLastDayOfMonth;




